<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center mb-5">Choose your role</h2>
      <app-select-role-form
        [roles]="roles"
        [placeholder]="placeholder"
        [selectedRole]="selectedRole"
        (submitEvent)="selectRole($event)"
      ></app-select-role-form>
    </div>
  </div>
</div>
